import React, {  useEffect, useState } from 'react';
import Login from './Login';


const TheLogin = (props) => {


    useEffect(() => {

    }, [])

    return (
        <div className="">
                <main className="body-content">
                  <Login/>
                </main>

        </div>
    );
}

export default TheLogin;